import { Injectable, inject } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import {
  LedgerAccountModel,
  LedgerAliasModel,
} from '../../../components/ledger/ledger.model';
import { LedgerReportsModel } from '../../../components/reports/ledger-reports.model';
import { BaseResponseDataModel } from '@magis-ui/magis-ui';

@Injectable({
  providedIn: 'root',
})
export class LedgerService {
  private apiService = inject(ApiService);

  getAccountDetails(
    accountId: number
  ): Observable<{ object: LedgerAccountModel }> {
    const url = `/ledger/${accountId}/`;
    return this.apiService
      .get<{ object: LedgerAccountModel }>(url)
      .pipe(map(data => data));
  }

  createLedger(
    category: number | null,
    branch: number | null,
    currency: number | null,
    title: string | null
  ): Observable<BaseResponseDataModel<null>> {
    const url = '/ledger/';
    const body = {
      category,
      branch,
      currency,
      title,
    };
    return this.apiService
      .post<BaseResponseDataModel<null>>(url, body)
      .pipe(map(data => data));
  }

  getTreasuryDetails(
    treasuryId: number
  ): Observable<{ object: LedgerAliasModel }> {
    return this.apiService
      .get<{
        object: LedgerAliasModel;
      }>(`/treasury/institutions/manage/${treasuryId}/`)
      .pipe(map(data => data));
  }

  createAliasLedger(body: {
    category: number;
    branch: number;
    currency: number;
    title: string;
  }): Observable<BaseResponseDataModel<null>> {
    const url = '/treasury/institutions/manage/';
    return this.apiService
      .post<BaseResponseDataModel<null>>(url, body)
      .pipe(map(data => data));
  }

  getLedgerReport(
    type: 'balance-sheet' | 'operating-result'
  ): Observable<{ object: LedgerReportsModel }> {
    const url =
      type === 'balance-sheet'
        ? `/ledger-global-report/bilan/`
        : '/ledger-global-report/operating_result/';

    return this.apiService
      .get<{ object: LedgerReportsModel }>(url)
      .pipe(map(data => data));
  }
}
